import rebase from "./config/rebase"
import { days, dbPrefix, gradeAssignmentLimit, gradeResult, sendBannerLimit, signUpForParticipantsLimit, signUpLimit } from "./Constants"
import moment from 'moment'
import 'moment/locale/pt-br'  // without this line it won't work
moment.locale('pt-br')

export const checkBannerFileExt = (filename) => {
    let fileExt = filename.split('.')[1]

    if (['png', 'jpg', 'jpeg'].includes(fileExt)) {
        return true
    }
    return false
}

export const reverseAndConcat = (str) => {
    return str.split("").reverse().join("")
}

export const validateEmail = (email) => {
    //eslint-disable-next-line
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
}

export const validateCpf = (cpf) => {
    //eslint-disable-next-line
    return /^\d+$/.test(cpf)
}

export const checkPaperFileExt = (filename) => {
    let fileExt = filename.split('.')[1]

    if ('docx' === fileExt) {
        return true
    }
    return false
}

export const getUsersByUID = async usersFromPaper => {
    const arr = []
    for (let index = 0; index < usersFromPaper.length; index++) {
        const cpf = usersFromPaper[index]
        const user = await rebase.fetch(dbPrefix + 'users/' + cpf, {
            asArray: false
        })
        arr.push(user)
    }
    return arr
}

export const snapshotToArray = (snapshot) => {
    const returnArr = []

    snapshot.forEach((childSnapshot) => {
        const item = childSnapshot.val()
        item.key = childSnapshot.key
        returnArr.push(item)
    })

    return returnArr
}

export const isChatroomAvailable = () => {
    for (const day of days) {
        for (const turn of day) {
            if (Date.now() > turn.start && Date.now() < turn.end) {
                return true
            }
        }
    }
    return false
}

export const isTableGenerationAvailable = () => {
    return false
}

export const isPaperGradesAvailable = () => {
    if (Date.now() > gradeResult) {
        return true
    }
    return false
}

export const convertTimestampToReadableDate = (timestamp, noTime = false) => {
    if (noTime) {
        return moment(new Date(timestamp)).format('DD/MM/YYYY')
    }
    return moment(new Date(timestamp)).format('DD/MM/YYYY HH:mm')
}

export const convertMomentToReadableDate = (momentO) => {
    return momentO.format("ddd, D MMMM YYYY, HH:mm")
}

export const toLocaleDS_BL = () => {
    return new Date(sendBannerLimit).toLocaleString()
}

export const isBannerSubsAvailable = () => {
    if (Date.now() < sendBannerLimit) {
        return true
    }
    return false
}

export const isSubscriptionForParticipantsAvailableAgain = () => {
    if (Date.now() > signUpForParticipantsLimit.min && Date.now() < signUpForParticipantsLimit.max) {
        return true
    }
    return false
}

export const isSubscriptionAvailable = () => {
    if (Date.now() > signUpLimit.min && Date.now() < signUpLimit.max) {
        return true
    }
    return false
}

export const isGradeAssignmentAvailable = () => {
    if (Date.now() < gradeAssignmentLimit.max && Date.now() > gradeAssignmentLimit.min) {
        return true
    }
    return false
}

export const ERROR_MESSAGES = [
    { code: "auth/wrong-password", translate: "Sua senha não confere com a nossa base" },
    { code: "auth/invalid-email", translate: "E-mail inválido." },
    { code: "auth/user-disabled", translate: "Usuário desabilitado." },
    { code: "auth/user-not-found", translate: "Usuário não encontrado." },
]